module.exports = __webpack_public_path__ + "assets/img/a7cbed0517a5ba0ab97e9136ea47cf75.svg";